<template>
  <b-overlay
      :show="loading"
      rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
            title="جزئیات فیلد سفارش"
        >
          <b-form
              ref="dutyquestionform"
              @submit.prevent
          >
            <b-row>

              <b-col
                  class="mt-2"
                  md="6"
                  offset-md="3"
              >
                <b-row>

                  <b-col md="8">
                    <b-form-group
                        label="عنوان"
                        label-for="Title"
                    >
                      <b-form-input
                          v-model="Form.Title"
                          autocomplete="off"
                          name="Title"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                        label="ترتیب"
                        label-for="Sort"
                    >
                      <b-form-input
                          v-model="Form.Sort"
                          autocomplete="off"
                          name="Sort"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group
                        label="لزوم پاسخگویی"
                        label-for="IsRequired"
                    >
                      <v-select
                          v-model="Form.IsRequired"
                          :options="enums('IsRequired')"
                          dir="rtl"
                          label="text"
                          :reduce="x => x.value"
                          :clearable="false"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group
                        label="نوع"
                        label-for="Type"
                    >
                      <v-select
                          v-model="Form.Type"
                          :options="enums('QuestionType')"
                          dir="rtl"
                          label="text"
                          :reduce="x => x.value"
                          :clearable="false"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                        label="واحد"
                        label-for="Unit"
                    >
                      <b-form-input
                          v-model="Form.Unit"
                          autocomplete="off"
                          name="Unit"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="8">
                    <b-form-group
                        label="Placeholder"
                        label-for="Placeholder"
                    >
                      <b-form-input
                          v-model="Form.Placeholder"
                          autocomplete="off"
                          name="Placeholder"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group
                        label="Regex"
                        label-for="Regex"
                    >
                      <b-form-input
                          v-model="Form.Regex"
                          autocomplete="off"
                          name="Regex"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group
                        label="گزینه ها"
                        label-for="DutyQuestionOption"
                    >
                      <b-form-tags
                          v-model="Form.Option"
                          name="DutyQuestionOption"
                          placeholder=""
                          add-button-text="افزودن"
                          add-button-variant="outline-primary"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        type="submit"
                        variant="primary"
                        class="mr-1"
                        @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                        variant="outline-secondary"
                        @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

export default {
  name: 'DutyQuestionDetails',
  components: {},
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Image: null,
        Description: null,
        Option: []
      },
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
    else{
      this.Form.DutyId = this.$route.query.dutyid
    }
  },
  methods: {
    save() {
      let url = this.$api.dutyquestion.add
      if (this.$route.params.id) {
        url = this.$api.dutyquestion.update
      }

      this.Form.DutyQuestionOption = []

      if (this.Form.Option){
        this.Form.Option.forEach(item=>{
          this.Form.DutyQuestionOption.push({Title: item})
        })
      }

      this.loading = true
      this.$http.post(
          url, this.Form,
      )
          .then(() => {
            this.back()
          })
          .finally(() => {
            this.loading = false
          })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    get() {
      this.loading = true
      this.$http.post(
          this.$api.dutyquestion.get, {
            Id: this.Form.Id,
          },
      )
          .then(res => {
            this.loading = false
            this.Form = res.data
            this.Form.Option = res.data.DutyQuestionOption.map(x=>x.Title)
          })
    },
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>
